/* app/js/src/components/batch-import/batch-import.scss */
.cursor-pointer {
  cursor: pointer;
}
.files-status-container::-webkit-scrollbar,
.batch-rules-container::-webkit-scrollbar,
.summary-container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.files-status-container::-webkit-scrollbar-button,
.batch-rules-container::-webkit-scrollbar-button,
.summary-container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.files-status-container::-webkit-scrollbar-corner,
.batch-rules-container::-webkit-scrollbar-corner,
.summary-container::-webkit-scrollbar-corner {
  background: transparent;
}
.files-status-container::-webkit-scrollbar-thumb:hover,
.batch-rules-container::-webkit-scrollbar-thumb:hover,
.summary-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.files-status-container::-webkit-scrollbar-thumb,
.batch-rules-container::-webkit-scrollbar-thumb,
.summary-container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.files-status-container::-webkit-scrollbar-thumb:hover,
.batch-rules-container::-webkit-scrollbar-thumb:hover,
.summary-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.files-status-container::-webkit-scrollbar-track:hover,
.batch-rules-container::-webkit-scrollbar-track:hover,
.summary-container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.files-status-container::-webkit-scrollbar-track,
.batch-rules-container::-webkit-scrollbar-track,
.summary-container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.input-group input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.input-group input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.input-group input.ng-invalid.ng-dirty[type=text],
.input-group input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-clear,
.btn,
.input-files + label {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-clear:focus,
.btn:focus,
.input-files + label:focus {
  outline-color: #ffffff;
}
.btn-clear:hover,
.btn:hover,
.input-files + label:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-clear,
.disabled.btn,
.input-files + label.disabled {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.input-group input[type=checkbox] {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
}
.input-group input[type=checkbox]:before {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  content: "";
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: -25%;
}
.input-group input[type=checkbox]:checked:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #232f3a;
}
.input-group input[type=checkbox]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  margin-bottom: 10px;
}
.input-group label {
  display: inline-block;
  margin-right: 13px;
  color: #7d8fa1;
}
.input-group input[type=text] {
  width: 305px;
  border-radius: 4px;
  vertical-align: middle;
}
.input-group:not(:last-child) {
  margin-bottom: 30px;
}
.input-group > * {
  vertical-align: middle;
}
.tasks .task {
  font-style: italic;
  letter-spacing: 0.1px;
  color: #232f3a;
  font-size: 12px;
}
.tasks .task-content {
  font-style: normal;
  margin-top: 14px;
}
:host {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  overflow: hidden;
  display: flex;
}
.input-files {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.bucket-options {
  display: flex;
  align-items: center;
}
.batch-rules-container,
.summary-container {
  overflow-y: scroll;
  height: 30%;
}
.files-status-container {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  max-height: 65vh;
}
.file-container {
  margin-bottom: 10px;
}
.file-label {
  margin-right: 10px;
}
.input-file-container {
  margin-bottom: 20px;
}
.left-side {
  padding-left: 105px;
  padding-top: 81px;
  width: 35%;
  background-color: #f1f3f4;
}
.right-side {
  padding-left: 105px;
  padding-top: 81px;
  padding-right: 81px;
  width: 65%;
  background-color: #ffffff;
  flex-direction: column;
  overflow-y: auto;
}
h1 {
  margin: 0;
  color: #232f3a;
  font-family: "Roboto";
  font-size: 36px;
  font-weight: bold;
  display: inline;
}
.input-files {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.input-files + label {
  margin-top: 30px;
}
.files-chosen {
  margin-top: 20px;
}
.btn {
  margin-top: 15px;
  width: 72px;
}
table {
  margin-bottom: 1vh;
  margin-top: 1vh;
}
table,
th,
td {
  border: 1px solid #e3e6ea;
  border-collapse: collapse;
  padding: 5px;
}
th {
  font-size: 13px;
  color: #879baf;
}
td {
  font-size: 12px;
  color: #232f3a;
}
.btn-align {
  width: 100px;
  float: right;
  display: inline;
}
.header-container {
  display: flex;
  justify-content: space-between;
}
.check-cell {
  width: 50px;
  text-align: center;
}
.name-cell {
  width: 250px;
}
.rule-cell {
  width: 250px;
}
.type-cell {
  width: 150px;
}
.date-cell {
  width: 200px;
}
.edit-cell {
  cursor: pointer;
  width: 50px;
  text-align: center;
}
.del-cell {
  cursor: pointer;
  width: 100px;
  text-align: center;
}
.svg-icon-export {
  cursor: pointer;
}
.summary {
  margin-top: 20px;
}
.summary > div {
  cursor: pointer;
}
input[type=checkbox] {
  cursor: pointer;
}
/*# sourceMappingURL=batch-import.css.map */
